<template>
  <vk-modal-body>
    <services-modal-header>
      Good news! {{ service.service_display_name || service.name }}
      is available in {{ selectedLocation.city }}
    </services-modal-header>
    <services-modal-body>
      <div class="d-flex fd-column">
        <div class="d-flex fd-column ai-center m-2">
          <div class="m-b-2">
            We've found some qualified pros for your project.
          </div>
          <img
              src="./assets/pro-matched.svg"
              width="100"
              height="86"
              selenium="matched-pros-image"
              class="m-l-2">
          <router-link
              :to="next"
              class="btn m-t-2 BUTTON-MODAL"
              selenium="next-modal-button">
            Next
          </router-link>
        </div>
        <div class="m-t-2 w-100 d-block text-center" v-if="pricingData.instructions">
          <div>
            Basic installation in your area starts at ${{pricingData.service_starting_price}}
          </div>
          <div class="d-flex w-100 fd-column:mo flex-0-1 m-y-4 TOGGLE-SECTION">
            <a
                class="link d-flex text-underline  text-small m-t-2 TOGGLE-LINK"
                @click="toggleInfo">
              <vk-icon name="information-filled" size="15" />
              <span>What does basic installation includes?</span>
            </a>
            <div v-if="toggle" class="p-x-1 INSTRUCTIONS-SECTION p-t-1:mo w-100:mo">
              Installation pricing starts at ${{ pricingData.service_starting_price }} and may
              increase depending on the Pro's assessment of the job and the level of
              difficulty to install. A basic installation job usually includes the following:
              <ul v-if="pricingData.instructions">
                <li v-for="instruction in instructionsParsed" :key="instruction">
                  {{ instruction }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </services-modal-body>
  </vk-modal-body>
</template>
<script>
import ServicesModalHeader from '../components/ServicesModalHeader';
import ServicesModalBody from '../components/ServicesModalBody';

export default {
  name: 'available-modal',
  components: {
    ServicesModalHeader,
    ServicesModalBody,
  },
  props: {
    selectedLocation: {
      type: Object,
      required: true,
    },
    service: {
      type: Object,
      required: true,
    },
    pricingData: {
      type: Object,
    },
  },
  data () {
    return {
      toggle: false,
      instructionsParsed: '',
    };
  },
  computed: {
    next () {
      return {
        name: 'jobrequest::details',
        params: {
          zipcode: this.selectedLocation.zipcode,
          serviceId: this.service.service_id || this.service.id,
        },
        query: {
          city: this.selectedLocation.city,
          state: this.selectedLocation.state,
          sourceID: this.$route.query.sourceID || 'browse',
        },
      };
    },
  },
  beforeUpdate () {
    const { instructions } = this.pricingData;
    if (typeof (instructions) === 'string') {
      this.instructionsParsed = instructions.split('.').filter(element => element);
    }
  },
  methods: {
    toggleInfo () {
      this.toggle = !this.toggle;
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .BUTTON-MODAL{
    width: 50%;
    max-width: 193px;
  }
  .INSTRUCTIONS-SECTION{
    width: 60%;
    text-align: left;
    font-size: 12px;
  }
  .TOGGLE-SECTION {
    justify-content: center;
    a {
      font-size: 12px;
    }
  }
  .TOGGLE-LINK {
    height: fit-content;
    align-items: center;
    justify-content: center;
    svg {
      padding-right: 2px;
    }
  }
</style>
